export enum RolesEnum {
  admin = 'admin',
  customer = 'customer', // to klient zakładany przez stronę www. On nie ma dostępu do Panelu Admina
  dispatcher = 'dispatcher', // to ten dyspozytor, czyli osoba, która w domyśle ma mieć możliwość przypisywania kierowców i robienia im zadań
  operator = 'operator', // to taki trochę lepszy dyspozytor, który będzie miał nieco więcej możliwości niż dispatcher ale mniej niż admin
  driver = 'driver', // to kierowca i to także osoba, która nie ma dostępu do Panelu Admina.
}
